import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './components/HomePage';
import EpisodesPage from './components/EpisodesPage';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import ThankYouPage from './components/ThankYouPage';
import NotFound from './components/NotFound';
import ServerError from './components/ServerError';

// admin pages
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminLayout from './components/admin/AdminLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminComments from './components/admin/AdminComments';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-Y49X6PRR09', {
        page_path: location.pathname,
      });
    }
  }, [location]);
};

const AppRoutes: React.FC = () => {
  usePageTracking();

  return (
    <Routes>
      {/* Public site layout */}
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="episodes" element={<EpisodesPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="thank-you" element={<ThankYouPage />} />
        <Route path="error/500" element={<ServerError />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* Admin login (unprotected) */}
      <Route
        path="/admin/login"
        element={
          <AdminLayout>
            <AdminLogin />
          </AdminLayout>
        }
      />

      {/* Protected admin dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AdminDashboard />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/comments"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AdminComments />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      {/* Catch-all for unknown admin routes */}
      <Route path="/admin/*" element={<Navigate to="/admin/login" />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;